import { createNamespacedHelpers } from 'vuex';
import { DefineActions, DefineGetters, DefineMutations } from 'vuex-type-helper';
import { Getters, Mutations, Actions, Customers, IndustrySector } from '@/models/Customer.model';
import { Type } from '@/models/App.model';

// Inital state
const state: Customers = {
  industries: [],
  industrySectors: [],
  // packagePrices: [],
  // !!TODO I know these prob shouldn't be hard coded but since they are unlikely to change and the pricing isn't coming from the DB I'm doing it quick&dirty for now
  packageTypes: [
    { id: 1, type: 'Marketing', icon: 'mdi-newspaper-variant' },
    { id: 2, type: 'Start-Up', icon: 'mdi-tray-arrow-up' },
    { id: 3, type: 'Silver', icon: 'mdi-star' },
    { id: 4, type: 'Gold', icon: 'mdi-gold' },
    { id: 5, type: 'Diamond', icon: 'mdi-diamond-stone' },
  ],
  paymentFrequencies: [
    { id: 1, type: 'N/A' },
    { id: 2, type: 'Monthly' },
    { id: 3, type: 'Annually' },
  ],
};

// Gets the values of our state usually called from components
const getters: DefineGetters<Getters, Customers> = {
  industries: (state) => state.industries,
  industrySectors: (state) => state.industrySectors,
  // packagePrices: (state) => state.packagePrices,
  packageTypes: (state) => state.packageTypes,
  paymentFrequencies: (state) => state.paymentFrequencies,

  // !!TODO I know these prob shouldn't be hard coded but since they are unlikely to change and the pricing isn't coming from the DB I'm doing it quick&dirty for now
  distributionTypes: (state) => {
    return [
      { id: 1, type: 'Locally' },
      { id: 2, type: 'Nationally' },
      { id: 3, type: 'Internationally' },
    ];
  },

  provinces: (state) => {
    return [
      {name: 'Eastern Cape', value: 'Eastern Cape'},
      {name: 'Free State', value: 'Free State'},
      {name: 'Gauteng', value: 'Gauteng'},
      {name: 'KwaZulu-Natal', value: 'KwaZulu-Natal'},
      {name: 'Limpopo', value: 'Limpopo'},
      {name: 'Mpumalanga', value: 'Mpumalanga'},
      {name: 'Northern Cape', value: 'Northern Cape'},
      {name: 'North West', value: 'North West'},
      {name: 'Western Cape', value: 'Western Cape'},
    ];
  },

  getIndustrySectorGroupsByIndustryId: (state) => (industryId: number): string[]  => {
    return industryId ? [...new Set(state.industrySectors.filter((item: IndustrySector) => item.industryId === industryId).map((item: IndustrySector) => item.groupName))] : [];
  },

  getIndustrySectorsByGroupName: (state) => (groupName: string): IndustrySector[]  => {
    return groupName ? state.industrySectors.filter((item: IndustrySector) => item.groupName === groupName) : [];
  },

  getIndustrySectorById: (state) => (industrySectorId: number): IndustrySector | undefined => {
    return industrySectorId ? state.industrySectors.find((item: IndustrySector) => item.id === industrySectorId) : undefined;
  },

  getPackageTypeById: (state) => (packageTypeId: number): Type | undefined => {
    return packageTypeId ? state.packageTypes.find((item: Type) => item.id === packageTypeId) : undefined;
  },

  getPaymentFrequencyById: (state) => (paymentFrequencyId: number): Type | undefined => {
    return paymentFrequencyId ? state.paymentFrequencies.find((item: Type) => item.id === paymentFrequencyId) : undefined;
  },
};
// TODO: Change mutation names to uppercase ( Standards )
// Sets values or changes to state. Must be called via an action.
const mutations: DefineMutations<Mutations, Customers> = {
  setIndustries(state, { industries }) {
    state.industries = industries;
  },

  setIndustrySectors(state, { industrySectors }) {
    state.industrySectors = industrySectors;
  },

  /*
  setPackagePrices(state, { packagePrices }) {
    state.packagePrices = packagePrices;
  },
  */
};

// Async functions that will contain the logic / service calls and commit mutations to state
const actions: DefineActions<Actions, Customers, Mutations, Getters> = {
  setIndustries({ commit }, payload) {
    commit('setIndustries', payload);
  },

  setIndustrySectors({ commit }, payload) {
    commit('setIndustrySectors', payload);
  },
  
  /*
  setPackagePrices({ commit }, payload) {
    commit('setPackagePrices', payload);
  },
  */
};

export const {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} = createNamespacedHelpers<Customers, Getters, Mutations, Actions>('CustomerModule');

export const CustomerModule = {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
